import axios from 'utils/axios';

// Get all dash users
export const getAllUsers = async ({ perPage = 10, pageNo = 1, query = '' }) => {
    const response = await axios.get(`users`, {
        params: { perPage, pageNo, query }
    });
    return response.data;
};

// create or update dash user
export const createOrUpdateUser = async (data) => {
    try {
        const response = await axios.post('users', { ...data });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

// access as admin; create user with admin rights for a deployment
export const accessAsAdmin = async (data) => {
    try {
        const response = await axios.post('users/access-as-admin', { ...data });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};
